






































































import {Component, Prop} from 'vue-property-decorator'
import {mixins} from 'vue-class-component'
import {Action, Getter, State} from 'vuex-class'
import {SubscriptionsState} from '@/store/modules/subscriptions'
import {
  Autorenew,
  FieldConfigs,
  Rate,
  Subscription,
  SubscriptionPlan,
  Toc,
  TocDetail,
  VehicleType,
} from '@/lib/kepler/interfaces'
import collect from 'collect.js'
import sdk from '../lib/kepler/sdk'
import {ProfileState} from '@/store/modules/profile'

import ConfirmDialogCallback from './ConfirmDialogCallback.vue'
import PlanTermsOfServiceDialog from '@/components/subscriptions/PlanTermsOfService.vue'
import DateHelper from '../lib/DateHelper'
import VuetifyColorHelper, {PlanColorMixin} from '@/lib/vuetify/VuetifyColorHelper'
import moment from 'moment'
import Utils from '@/utils'
import ServiceMesh from '@/lib/serviceMesh'
import {AppConfigState} from '@/store/modules/configuration'
import LoaderDialog from '@/views/LoaderDialog.vue'

@Component({
  components: {
    Divider: Utils.loadComponent('proxy/Divider'),
    Avatar: Utils.loadComponent('proxy/Avatar'),
    VehicleIcon: Utils.loadComponent('VehicleIcon'),
    Sheet: Utils.loadComponent('proxy/Sheet'),
    Btn: Utils.loadComponent('proxy/Btn'),
    PlanDetailRates: Utils.loadView('PlanDetailRates'),
    Container: Utils.loadComponent('proxy/Container'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    CardTitle: Utils.loadComponent('proxy/Card/CardTitle'),
    CardText: Utils.loadComponent('proxy/Card/CardText'),
    GradientCard: Utils.loadComponent('GradientCard'),
    Button: Utils.loadComponent('Button'),
    PlanTermsOfService: Utils.loadComponent('subscriptions/PlanTermsOfService'),
    Tabs: Utils.loadComponent('proxy/Tabs/Tabs'),
    Tab: Utils.loadComponent('proxy/Tabs/Tab'),
    TabItem: Utils.loadComponent('proxy/Tabs/TabItem'),
    TabItems: Utils.loadComponent('proxy/Tabs/TabItems'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
  },
  mixins: [PlanColorMixin],
})
export default class PlanDetail extends mixins<PlanColorMixin>(PlanColorMixin) {
  @State('subscriptions') public subscriptionsState!: SubscriptionsState
  @State('profile') public profileState!: ProfileState
  @State('configuration') public configState!: AppConfigState
  @State((state) => !!state.configuration.appConfig.fields_configuration?.hide_free_plan_string) public hideFree !: boolean

  @Getter('isLogged') public isLogged!: boolean
  @Getter('fieldConfigs') public fieldConfigs?: FieldConfigs
  @Getter('monoMode') public monoMode!: boolean
  @Getter('defaultPlan') public defaultPlan!: SubscriptionPlan | null

  @Action('getPlans') public getPlans!: () => Promise<SubscriptionPlan[]>
  @Action('getRates') public getRates!: (id: string) => Promise<Rate[]>
  @Action('getSubscriptions') public getSubscriptions!: () => Promise<Subscription[]>
  @Action('subscribe') public subscribe!: (id: string) => Promise<Subscription>
  @Action('autorenew') public autorenew!: (p: Autorenew) => Promise<Subscription>
  @Action('setTopbarTitle') public setTopbarTitle!: (t: string) => void

  @Prop() public planProp?: SubscriptionPlan
  @Prop({type: Boolean, default: false}) public hideCta!: boolean

  public planTocs: Toc | TocDetail | null = null
  public plan: SubscriptionPlan | null = null
  public isDefault: boolean = false
  public alreadySubscribed: boolean = false
  public tocsApproved: boolean = false
  public selectedMode: number = 0
  protected planCSS: string | null = null

  public get durationRecursive() {
    if (!this.fieldConfigs?.hide_plan_duration) {
      const obj: { [key: number]: string } = {
        7: 'activities.plans.card.duration.weekly',
        30: 'activities.plans.card.duration.monthly',
        60: 'activities.plans.card.duration.two-monthly',
        90: 'activities.plans.card.duration.quarterly',
        365: 'activities.plans.card.duration.annual',
      }
      if (this.plan) {
        const d = this.plan.duration

        if (obj.hasOwnProperty(d)) {
          return this.$t(obj[d])
        } else {
          if (d > 3000) {
            return this.$t('activities.plans.card.duration.unlimited')
          } else if (!(d % 30)) {
            return this.$t('activities.plans.card.duration.months', {n: d / 30})
          } else {
            return this.humanizeDuration(this.plan.duration, 'days')
          }
        }
      }
    }
    return ''
  }

  public get rates(): Rate[] | null {
    return this.plan?.rates || null
  }

  public get duration() {
    const d = this.plan?.duration
    return d && d < 3000 ? this.humanizeDuration(d, 'days') : null
  }

  public get humanizedBillingCycle() {
    const cases: { [key: number]: string } = {
      1: this.$t('common.time_units.day'),
      7: this.$t('common.time_units.week'),
      30: this.$t('common.time_units.month'),
      60: this.$t('common.time_units.two-month'),
      90: this.$t('common.time_units.quarter'),
      365: this.$t('common.time_units.year'),
    }
    if (this.plan) {
      const d = this.plan.billing_cycle

      // noinspection IfStatementWithTooManyBranchesJS
      if (cases.hasOwnProperty(d)) {
        return cases[d]
      } else if (!(d % 30)) {
        return this.$t('common.time_units.months', {n: d / 30})
      } else if (!(d % 7)) {
        return this.$t('common.time_units.weeks', {n: d / 7})
      } else {
        return this.$t('common.time_units.days', {n: d})
      }
    }
  }

  public get payCycle() {
    switch (this.plan?.billing_cycle) {
      case 30:
        return this.$t('common.calendar.monthly')
      case 365:
        return this.$t('common.time_units.yearly')
      default:
        return ''
    }
  }

  public get planVehicleTypes() {
    if (this.rates) {
      const t: Record<string, VehicleType[]> = {}
      for (const rate of this.rates) {
        const bmArr = rate.booking_mode.split(',')
        const type = rate.vehicle_category.type
        bmArr.forEach((bm) => {
          if (!t[bm]) {
            t[bm] = [type]
          } else if (!t[bm].includes(type)) {
            t[bm].push(type)
          }
        })
      }
      return t
    }
    return null
  }

  public get planAlert() {
    const obj = {notice: this.plan?.notice, color: 'transparent'}
    if (obj.notice) {
      const arr = obj.notice.split('|')
      obj.notice = arr[0]
      if (arr[1]) {
        obj.color = VuetifyColorHelper.color(arr[1])
      }
    }
    return obj
  }

  protected get planColors() {
    return this.plan ? this.getPlanColors(this.plan.color, this.isDefault) : null
  }

  public humanizeDuration(val: number, unit: any) {
    return DateHelper.humanizeDuration(val, unit)
  }

  // Colors

  public isSubscribed() {
    if (sdk.people.isLogged()) {
      (this.profileState as any).subscriptions.forEach((subscription: Subscription) => {
        const now = moment().unix()
        const planEnd = subscription.end_timestamp
        if (subscription.plan.id === this.$route.params.id && now < planEnd) {
          this.alreadySubscribed = true
        }
      })
    }
  }

  public serviceColor(mode: string) {
    return ServiceMesh.colors[mode + 'CAR']
  }

  public subscribeFlow() {
    const planId = this.plan?.id
    const er = (e: Error) => {
      this.$log(e, 3)
    }
    if (planId) {
      this.checkPlanTos().then(() =>
        this.alreadyHasPlanCheck().then(() =>
          this.askConfirm().then(() =>
            this.$dialog.open(LoaderDialog).then((idx) =>
              this.subscribe((planId))
                .finally(() => {
                  this.$dialog.close(idx)
                })
                .then((s) => {
                  if (s.plan.renewable) {
                    this.askAutoRenew().then(() => {
                      this.autorenew({subscription_id: s.id, status: true})
                    }).finally(this.confirmBought)
                  } else {
                    this.confirmBought()
                  }
                }))))).catch(er)
    }
  }

  public checkPlanTos() {
    return new Promise<void>((resolve) => {
      if (!this.tocsApproved && this.planTocs) {
        this.$dialog.open(PlanTermsOfServiceDialog, {
          props: {
            confirmCallback: () => {
              this.tocsApproved = true
              resolve()
            },
            toc: this.planTocs,
            plan: this.plan,
          },
        })
      } else {
        resolve()
      }
    })

  }

  // Subscription dialog flow

  public alreadyHasPlanCheck() {
    return new Promise<void>((confirmCallback, cancelCallback) => {
      if (this.alreadySubscribed) {
        this.$dialog.open(ConfirmDialogCallback, {
          props: {
            code: '',
            title: this.$t('subscription.already_have_a_subscription_title'),
            subtitle: this.$t('subscription.already_have_a_subscription'),
            confirmText: '',
            imageState: null,
            confirmCallback,
            cancelCallback,
          },
        })
      } else {
        confirmCallback()
      }
    })
  }

  public askConfirm() {
    return new Promise((confirmCallback, cancelCallback) => {
      this.$dialog.open(ConfirmDialogCallback, {
        props: {
          code: '',
          title: this.$t('subscription.confirm.title'),
          subtitle: this.$t('subscription.confirm.subtitle', {
            name: this.plan ? this.plan.name : '',
            cost: this.plan ? this.$currency(this.plan.cost) : '',
            duration: this.duration ? this.duration : '',
            cycle: this.payCycle,
          }),
          confirmText: this.$t('subscription.confirm.button_affirmative'),
          cancelText: this.$t('subscription.confirm.button_negative'),
          imageState: this.$t('subscription.confirm.image_url'),
          singleAction: false,
          confirmCallback,
          cancelCallback,
        },
      })
    })
  }

  public askAutoRenew() {
    return new Promise((confirmCallback, cancelCallback) => {
      this.$dialog.open(ConfirmDialogCallback, {
        props: {
          code: '',
          title: this.$t('subscription.autorenew.title'),
          subtitle: this.$t('subscription.autorenew.subtitle'),
          confirmText: this.$t('subscription.autorenew.button_affirmative'),
          cancelText: this.$t('subscription.autorenew.button_negative'),
          imageState: this.$t('subscription.autorenew.image_url'),
          singleAction: false,
          emitConfirm: true,
          showCloseButton: false,
          confirmCallback,
          cancelCallback,
        },
      })
    })
  }

  public confirmBought() {
    this.$dialog.open(ConfirmDialogCallback, {
      props: {
        code: '',
        title: this.$t('subscription.confirmed.title'),
        subtitle: this.$t('subscription.confirmed.subtitle'),
        confirmText: this.$t('subscription.confirmed.button_affirmative'),
        imageState: this.$t('subscription.confirmed.image_url'),
        singleAction: true,
        emitConfirm: true,
        showCloseButton: false,
        confirmCallback: () => {
          this.getSubscriptions().then(() => {
            this.$router.push({name: 'my subscriptions'})
          })
        },
      },
    })
  }

  protected checkIsLight(color: string) {
    return VuetifyColorHelper.lightContrast(VuetifyColorHelper.color(color))
  }

  protected vtColor(vehicleType: string) {
    return ServiceMesh.colors[vehicleType.toUpperCase()]
  }

  // Lifecycle

  protected init(plans: SubscriptionPlan[]) {
    this.isDefault = this.defaultPlan?.id === this.plan?.id
    if ((this.profileState as any).subscriptions === null && sdk.people.isLogged()) {
      this.getSubscriptions()
    }
    this.isSubscribed()

    if (!this.planProp) {
      const c = collect(plans)
      const id = this.$route.params.id
      this.plan = c.firstWhere('id', id)
    } else {
      this.plan = this.planProp
    }

    if (this.plan?.toc_id && sdk.people.isLogged()) {
      sdk.subscription.planTocs(this.plan.toc_id).then((data) => {
        this.planTocs = data.data
      })
      this.setTopbarTitle(this.plan.name)
    }
  }

  protected created() {
    if (!this.subscriptionsState.plans?.length) {
      this.getPlans().then(this.init)
    } else {
      this.init(this.subscriptionsState.plans)
    }
  }

  protected mounted() {
    this.planCSS = this.getPlanCSS(this.isDefault)
  }
}
